import Model from '~/models/Model';

export default class Invitation extends Model {
  resource() {
    return 'v1/invitations';
  }

  async $findByToken(token: string) {
    // @ts-ignore
    const endpoint = this.endpoint();

    this.params({ token });

    const response = await this.request({
      method: 'GET',
      url: `${endpoint}/by-token${this._builder.query()}`,
    });

    return response?.data?.data;
  }

  static $findByToken(token: string) {
    const self = new this();

    return self.$findByToken(token);
  }

  async resend() {
    // @ts-ignore
    const endpoint = this.endpoint();

    const response = await this.request({
      method: 'PUT',
      url: `${endpoint}/resend`,
    });

    return response?.data?.data;
  }
}
